import { StageIcon, stageLabel } from "@/components/StageIcon";

export default function StagePill({ stage }) {
    const s = stage || "planned";
    const cls = `stage-pill stage-${s} inline-flex items-center gap-1`;
    return (
        <span className={cls} data-testid={`stage-${s}`}>
            <StageIcon stage={s} size={12} strokeWidth={2} />
            <span>{stageLabel(s).toLowerCase()}</span>
        </span>
    );
}
